import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth.jsx";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        setUser(r.data.user);
        // clear hash
        window.history.replaceState(null, "", "/admin/forms");
        navigate("/admin/forms", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Sign-in failed";
        toast.error(msg);
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#71717A] font-mono text-xs">
      SIGNING YOU IN…
    </div>
  );
}
